export function loadUrls(ctx, payload) {
    return ctx.dispatch('LOAD_URLS', payload);
}



// WEBPACK FOOTER //
// ./js/launch/actions/urlActions.js